module.exports = __webpack_public_path__ + "src/assets/games/9/85.jpg";